const obj = {
  id: 0,
  eventId: 0,
  title: '',
  description: '',
  startDate: '',
  startTime: '',
  endTime: '',
  restrictedToAssociates: false,
}

export default function ScheduleModel(params = obj) {
  return { ...obj, ...params, };
};
